import './index.css'
import React from 'react'
import FullSizeItemsYouVeSampledSlider from 'containers/FullSizeItemsYouVeSampledSlider/containers/Content'
import Section from 'components/Section'

export default function FullSizeItemsYouVeSampled ({ productVariant }) {
  return (
    <Section className='quick-shop-full-size-items-you-ve-sampled'>
      <FullSizeItemsYouVeSampledSlider productVariant={productVariant} />
    </Section>
  )
}
